import type { MODAL_TYPE_MOBILE, MODAL_TYPE_PC } from '@module/types/modal/type';
import type { JSX } from 'react';
import { create, type StateCreator } from 'zustand';

type ModalType = keyof typeof MODAL_TYPE_PC | keyof typeof MODAL_TYPE_MOBILE;

export interface GlobalModal<T = any> {
  type?: ModalType;
  options?: T;
  id?: string;
  content?: JSX.Element;
  /** @description 모달 backdrop click시 event */
  onClickOutside?: () => void;
  noOverlay?: boolean;
}

interface ModalState {
  modal: GlobalModal[];
  pushModal: <T>(newModal: GlobalModal<T>) => void;
  unshiftModal: <T>(newModal: GlobalModal<T>) => void;
  popModal: () => void;
  clearModals: () => void;
  updateModal: (index: number, newModal: GlobalModal) => void;
}

const store: StateCreator<ModalState, [], [], ModalState> = (set) => {
  return {
    modal: [],
    pushModal: (newModal) =>
      set((state) => {
        return { modal: [...state.modal, newModal] };
      }),
    unshiftModal: (newModal) =>
      set((state) => {
        return { modal: [newModal, ...state.modal] };
      }),
    popModal: () => set((state) => ({ modal: state.modal.slice(0, -1) })),
    clearModals: () => set(() => ({ modal: [] })),
    // 특정 인덱스의 모달을 커스텀하게 수정하는 함수
    updateModal: (index, newModal) =>
      set((state) => ({
        modal: state.modal.map((modal, i) => (i === index ? newModal : modal)),
      })),
  };
};

const useModalStore = create(store);

export default useModalStore;
